(() => {
  const root = document.querySelector('[data-vivonu-concierge]');
  if (!root) return;
  const launch = root.querySelector('[data-vc-open]');
  const close = root.querySelector('[data-vc-close]');
  const minimize = root.querySelector('[data-vc-minimize]');
  const mini = root.querySelector('[data-vc-mini]');
  const expand = root.querySelector('[data-vc-expand]');
  const miniClose = root.querySelector('[data-vc-mini-close]');
  const panel = root.querySelector('#vc-dialog');
  if (![launch, close, minimize, mini, expand, miniClose, panel].every(Boolean)) return;

  const setExpanded = (expanded) => {
    launch.setAttribute('aria-expanded', String(expanded));
    expand.setAttribute('aria-expanded', String(expanded));
  };
  const hidePanel = () => {
    if (panel.open) {
      if (typeof panel.close === 'function') panel.close();
      else panel.removeAttribute('open');
    }
    root.classList.remove('vc-is-open');
    setExpanded(false);
  };
  const openPanel = () => {
    mini.hidden = true;
    if (!panel.open) {
      // A non-modal floating dialog lets customers keep using the storefront.
      if (typeof panel.show === 'function') panel.show();
      else panel.setAttribute('open', '');
    }
    root.classList.add('vc-is-open');
    setExpanded(true);
    close.focus();
  };
  const minimizePanel = () => {
    hidePanel();
    mini.hidden = false;
    root.classList.add('vc-is-minimized');
    expand.focus();
  };
  const dismiss = () => {
    hidePanel();
    mini.hidden = true;
    root.classList.remove('vc-is-minimized');
    launch.focus();
  };

  launch.setAttribute('aria-expanded', 'false');
  launch.addEventListener('click', openPanel);
  expand.addEventListener('click', () => {
    root.classList.remove('vc-is-minimized');
    openPanel();
  });
  minimize.addEventListener('click', minimizePanel);
  close.addEventListener('click', dismiss);
  miniClose.addEventListener('click', dismiss);
  panel.addEventListener('cancel', event => {
    event.preventDefault();
    dismiss();
  });
  panel.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      event.preventDefault();
      dismiss();
    }
  });
})();